// extracted by mini-css-extract-plugin
var _1 = "ProfileLabelsWidget-modulecontent__dWA3k WidgetContentContainer-moduleWidgetContentContainer__HxIkI";
var _2 = "ProfileLabelsWidget-modulewidget__pR441 Widget-moduleWidget__bcnWB";
export { _1 as "content", _2 as "widget" }
